module.exports = __webpack_public_path__ + "img/subway.aae72668.webp";